module.exports = "<div title=\"{{title}}\">\n    <i class=\"ssf-warning__icon fa fa-exclamation-circle\" aria-hidden=\"true\"></i>\n    <span class=\"ssf-warning__text\">\n        {{text}}\n    </span>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/shared/components/warning/warning.component.html
// module id = 848
// module chunks = 3